import { render, staticRenderFns } from "./ProfileUserEditForm.vue?vue&type=template&id=3720cf25"
import script from "./ProfileUserEditForm.vue?vue&type=script&lang=js"
export * from "./ProfileUserEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports